import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'src/store/redux';

import { ClassCodePathResponse } from './types';

export const studentDesmosApi = createApi({
  reducerPath: 'student-desmos',
  baseQuery: baseQuery('studentDesmos'),
  endpoints: (builder) => ({
    getClassCodePath: builder.query<ClassCodePathResponse, string>({
      query: (code) => ({
        url: '/class-code-path',
        method: 'POST',
        body: { code },
      }),
    }),
  }),
});

export const { useGetClassCodePathQuery } = studentDesmosApi;
